import { Service } from "./Service.js";

class ConsoleLogger {
  #debug = window.debug === true;

  log(level, message, ...data) {
    if (this.#logLevels[level] !== true) {
      return;
    }
    console[level](...[`[${this.#timestamp}] ${message}`, ...data]);
  }

  get #logLevels() {
    return {
      log: this.#debug,
      debug: this.#debug,
      info: this.#debug,
      warn: this.#debug,
      error: true,
    };
  }

  get #timestamp() {
    return new Date().toLocaleTimeString("en-US", {
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      fractionalSecondDigits: 3,
    });
  }
}

class SentryLogger {
  #sentry = window.Sentry;

  log(level, message, ...data) {
    this.#sentry.addBreadcrumb({
      level,
      message,
      category: "logging",
      data,
    });
  }
}

export class LoggingService extends Service {
  loggers = [];

  constructor() {
    super();
    this.loggers = [new ConsoleLogger(), new SentryLogger()];
  }

  log(message, ...data) {
    this.#logEvent("log", message, ...data);
  }

  debug(message, ...data) {
    this.#logEvent("debug", message, ...data);
  }

  info(message, ...data) {
    this.#logEvent("info", message, ...data);
  }

  warn(message, ...data) {
    this.#logEvent("warn", message, ...data);
  }

  error(message, ...data) {
    this.#logEvent("error", message, ...data);
  }

  #logEvent(level, message, ...data) {
    for (const logger of this.loggers) {
      logger.log(level, message, ...data);
    }
  }
}
